import React, { Fragment } from 'react';
import ReactHtmlParser from 'html-react-parser';
import Modal from 'react-responsive-modal';
import { Carousel } from 'react-responsive-carousel';
import $ from 'jquery';
import LogoBlack from '../../../../assets/icons/logo-black.svg';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Element from '../../../../components/element';
import { colors } from '../../../../config/theme';

class Message extends React.Component {
  constructor(props) {
    super(props);
    this.renderLink = this.renderLink.bind(this);
    this.state = {
      showSubPage: false
    };
    this.showSubPage = this.showSubPage.bind(this);
    this.renderImages = this.renderImages.bind(this);
  }

  componentDidMount() {
    const { rawAnswers, storeAnswer, index } = this.props;
    if (rawAnswers) {
      this.setState(rawAnswers);
    } else {
      // storeAnswer(index, this.state);
    }
  }

  showSubPage() {
    this.setState(
      {
        showSubPage: !this.state.showSubPage
      },
      () => $('.main-content').focus()
    );
  }

  renderLink(shouldBeBefore) {
    const { link } = this.props;
    if (
      (link && shouldBeBefore && link.isBeforeMessage) ||
      (link && !shouldBeBefore && !link.isBeforeMessage)
    ) {
      if (link.subPage) {
        return (
          <h3 className="survey-link">
            <a onClick={this.showSubPage}>{ReactHtmlParser(link.text)}</a>
          </h3>
        );
      } else {
        return (
          <h3 className="survey-link">
            <a href={link.src} download>
              {ReactHtmlParser(link.text)}{' '}
            </a>
          </h3>
        );
      }
    }
  }

  renderImages() {
    const { image, mobileImages, isMobile } = this.props;

    if (isMobile && mobileImages) {
      return (
        <Carousel showStatus={false} showThumbs={false}>
          {mobileImages.map((item, index) => {
            return (
              <div>
                <img src={item.src} alt={item.alt} />
              </div>
            );
          })}
        </Carousel>
      );
    } else if (this.props.image) {
      return (
        <div>
          <img className="survey-image" src={image.src} alt={image.alt} />
        </div>
      );
    }

    // if (this.props.image) {
    //   return (
    //     <div>
    //       <img className="survey-image" src={image.src} alt={image.alt} />
    //     </div>
    //   )
    // }
  }

  render() {
    const {
      message,
      image,
      mobileImages,
      title,
      link,
      className,
      subText
    } = this.props;

    return (
      <div className={`${className}`}>
        <Modal
          classNames={{
            modal: 'feedback-modal',
            overlay: 'feedback-overlay',
            closeButton: 'modal-close-btn'
          }}
          open={this.state.showSubPage}
          center
          showCloseIcon
          animationDuration={100}
          onClose={this.showSubPage}
          closeOnOverlayClick
          closeOnEsc
          closeIconSvgPath={
            <path
              strokeLinecap="round"
              stroke="black"
              strokeWidth="2"
              d="M 10,10 L 30,30 M 30,10 L 10,30"
            />
          }
        >
          <div>
            {this.props.isMobile && (
              <div className="mobile-padding">
                <img src={LogoBlack} className="modal-logo" alt="header" />
              </div>
            )}

            <div className="surveys-intro row collapse">
              <div className="small-12 columns">
                <h2 className="survey-subpage-title">
                  {link && link.subPage && ReactHtmlParser(link.subPage.title)}
                </h2>
                <h3>
                  {link &&
                    link.subPage &&
                    ReactHtmlParser(link.subPage.message)}
                </h3>
              </div>
            </div>
            {this.props.isMobile && (
              <Fragment>
                <br />
                <br />
              </Fragment>
            )}
          </div>
        </Modal>
        <div>
          <div className="surveys-intro row collapse">
            {title && (
              <div>
                <Element
                  type="p"
                  fontFamily="GTAM"
                  fontSize="14px"
                  marginBottom="8px"
                >
                  {ReactHtmlParser(title.text)}
                </Element>
                {title.image && !this.props.isMobile ? (
                  <img
                    className="survey-title-image"
                    src={title.image.src}
                    alt={title.image.alt}
                  />
                ) : null}
              </div>
            )}
            {this.renderLink(true)}
            <Element
              type="p"
              fontFamily="GTAM"
              fontSize="14px"
              color={colors.dustyGray}
            >
              {message ? ReactHtmlParser(message) : ''}
            </Element>
            {this.props.isMobile && this.renderLink()}
            {title && title.image && this.props.isMobile ? (
              <div className="survey-title-image">
                <img
                  src={
                    title.image.mobileImgSrc
                      ? title.image.mobileImgSrc
                      : title.image.src
                  }
                  alt={title.image.alt}
                />
              </div>
            ) : null}
            {this.renderImages()}
            <Element type="p" fontFamily="GTAM" fontSize="14px" color="#222222">
              {subText ? ReactHtmlParser(subText) : ''}
            </Element>
          </div>
          {!this.props.isMobile && this.renderLink()}
        </div>
      </div>
    );
  }
}

export default Message;
